import * as React from 'react';
import * as styles from './Filters.css';

interface IFiltersProps {
  filters: React.ReactNode;
}

export function Filters({ filters }: IFiltersProps) {
  return (
    <div className={styles['filters']}>
      <ul className={styles['list']}>
        {React.Children.map(filters, (filter, index) => (
          <li className={styles['list__item']} key={index}>
            {filter}
          </li>
        ))}
      </ul>
    </div>
  );
}
